// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_i3-0";
export var buttonContainer = "_i3-3";
export var cancelButton = "_i3-4";
export var headerSection = "_i3-6";
export var headerTitle = "_i3-9";
export var messageSideLeft = "_i3-1";
export var messageSideRight = "_i3-2";
export var orderNumberContainer = "_i3-7";
export var orderNumberLabel = "_i3-8";
export var submitButton = "_i3-5";